'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('../../../common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'SEO Signup or Login Button',

    propTypes: {
        isUserLoggedIn: _react2['default'].PropTypes.bool.isRequired,
        homeUrl: _react2['default'].PropTypes.string.isRequired,
        buttonText: _react2['default'].PropTypes.string.isRequired
    },

    renderButton: function renderButton() {
        var defaultButtonClass = {
            buttonTextColor: 'white',
            buttonColor: 'goldenrod',
            buttonBorderColor: 'goldenrod',
            buttonHoverColor: 'white',
            buttonHoverTextColor: 'goldenrod'
        };
        var buttonContent = {
            buttonText: this.props.buttonText,
            buttonLink: this.props.homeUrl
        };
        return _react2['default'].createElement(_button2['default'], _extends({}, defaultButtonClass, buttonContent, this.props));
    },
    renderSignupButton: function renderSignupButton() {
        var linkClassName = 'm-button bg-goldenrod hc-goldenrod border-1-goldenrod' + ' hbg-white c-white progress-button state-loading m-marketing-page--button';
        var linkClassName = this.props.buttonClass || linkClassName;
        var buttonContent = {
            buttonText: this.props.linkText,
            buttonLink: this.props.signUpUrl
        };
        return _react2['default'].createElement(_button2['default'], _extends({ className: linkClassName }, buttonContent, this.props));
    },
    render: function render() {
        var className;
        if (!this.props.isIntegration) {
            className = 'l-padding-t-10 l-padding-b-10 text-center m-marketing-page--try-it-free';
        }
        return _react2['default'].createElement(
            'div',
            { className: className },
            this.props.isUserLoggedIn ? this.renderButton() : this.renderSignupButton()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/signup-or-login-button.jsx
 ** module id = 1210
 ** module chunks = 0
 **/